import React from 'react';
import PropType from 'prop-types';
import {
  Input, Title, Wrapper, Asterisk, Texts, ErrorMessage, Warning, CharCounter
} from 'Common/Components/StandardTextField/styled';

const StandardTextField = ({
  value, name, disabled, onChange, placeholder, title, mandatory, error, errorMessage, className, boldTitle, type, min, max, step, id, onBlur, autoComplete, maxLength, useIcon
}) => (
  <Wrapper className={ className }>
    <Texts>
      {title && <Title boldTitle={ boldTitle } error={ error }>{title}</Title>}
      {mandatory && <Asterisk>*</Asterisk>}
    </Texts>
    <Input
      name={ name }
      value={ value ?? '' }
      disabled={ disabled }
      onChange={ (e) => onChange(e.target.value) }
      isEmpty={ value ? value.length === 0 : true }
      placeholder={ placeholder }
      error={ error }
      type={ type }
      min={ min }
      max={ max }
      step={ step }
      id={ id }
      onBlur={ onBlur }
      autoComplete={ autoComplete }
      maxLength={ maxLength }
    />
    {useIcon && error && <Warning />}
    {error && <ErrorMessage>{ errorMessage }</ErrorMessage>}
    {!!maxLength && <CharCounter>{`${value?.length ?? 0}/${maxLength}`}</CharCounter>}
  </Wrapper>
);

StandardTextField.defaultProps = {
  disabled: false,
  placeholder: '',
  value: '',
  mandatory: false,
  error: false,
  className: '',
  boldTitle: false,
  type: 'text',
  id: '',
  onBlur: () => {},
  autoComplete: 'off',
  maxLength: null,
  useIcon: true
};

StandardTextField.propTypes = {
  value: PropType.string,
  name: PropType.string.isRequired,
  disabled: PropType.bool,
  onChange: PropType.func.isRequired,
  placeholder: PropType.string,
  mandatory: PropType.bool,
  error: PropType.bool,
  boldTitle: PropType.bool,
  className: PropType.string,
  type: PropType.string,
  id: PropType.string,
  onBlur: PropType.func,
  autoComplete: PropType.string,
  maxLength: PropType.number
};

export default StandardTextField;
